import React, { useEffect, useState } from 'react';
import dashboardService from '../../services/dashboardService';
import styles from './PendingAmountList.module.scss';
import { formatCurrency, formatDateTime } from '../../utils/helpers';

interface OverdueInvoiceRow {
  customer_name: string;
  phone_number: string;
  total_amount: number;
  invoice_id: string;
  created_at: string;
}

const OverdueInvoiceList: React.FC = () => {
  const [overdueList, setOverdueList] = useState<OverdueInvoiceRow[]>([]);
  const [search, setSearch] = useState('');
  const [filtered, setFiltered] = useState<OverdueInvoiceRow[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const data = await dashboardService.getOverdueInvoiceList();
        setOverdueList(Array.isArray(data) ? data : []);
        setFiltered(Array.isArray(data) ? data : []);
      } catch (err) {
        setOverdueList([]);
        setFiltered([]);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (!search) {
      setFiltered(overdueList);
    } else {
      const s = search.toLowerCase();
      setFiltered(
        overdueList.filter(row =>
          row.customer_name.toLowerCase().includes(s) ||
          row.phone_number.toLowerCase().includes(s) ||
          row.invoice_id.toLowerCase().includes(s) ||
          formatCurrency(row.total_amount).toLowerCase().includes(s) ||
          formatDateTime(row.created_at).toLowerCase().includes(s)
        )
      );
    }
  }, [search, overdueList]);

  return (
    <div className={styles.pendingAmountPage}>
      <h2 className={styles.title}>Overdue Invoice</h2>
      <div className={styles.searchBar}>
        <input
          type="text"
          placeholder="Search by customer name, phone, amount, invoice number, or date..."
          value={search}
          onChange={e => setSearch(e.target.value)}
          className={styles.searchInput}
        />
      </div>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Customer Name</th>
              <th>Phone Number</th>
              <th>Invoice Number</th>
              <th>Total Amount</th>
              <th>Created Date</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan={5} className={`${styles.centerMessage} centerMessage`}>Loading...</td></tr>
            ) : Array.isArray(filtered) && filtered.length === 0 ? (
              <tr><td colSpan={5} className={`${styles.centerMessage} centerMessage`}>No data found.</td></tr>
            ) : (
              Array.isArray(filtered) &&
              filtered.map((row, idx) => (
                <tr key={idx}>
                  <td>{row.customer_name}</td>
                  <td>{row.phone_number}</td>
                  <td>{row.invoice_id}</td>
                  <td>{formatCurrency(row.total_amount)}</td>
                  <td>{formatDateTime(row.created_at)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default OverdueInvoiceList; 